import { LOCALE_ID, NgModule } from '@angular/core';
import { CommonModule, LocationStrategy, PathLocationStrategy } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import pt from '@angular/common/locales/pt';
import { registerLocaleData } from '@angular/common';



registerLocaleData(pt);

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FontAwesomeModule, FaIconLibrary } from '@fortawesome/angular-fontawesome';
import {
  faChevronLeft,
  faChevronRight,
  faCircleExclamation,
  faSearch,
  faHeart,
  faDownload,
  faPlus,
  faXmark,
  faMagnifyingGlass,
  faFileDownload,
  faPaperPlane,
  faArrowLeft,
  faArrowRight,
  faArrowUpRightFromSquare,
  faFile,
  faHandPointUp,
  faEye,
  faEnvelope,
  faClone,
  faList,
  faSort,
  faCircleCheck,
} from '@fortawesome/free-solid-svg-icons';

import { DefaultLayoutComponent } from './containers/default-layout/default-layout.component';
import { FooterComponent } from './components/shared/footer/footer.component';
import { HeaderComponent } from './components/shared/header/header.component';
import { SidebarComponent } from './components/shared/sidebar/sidebar.component';
import { MenuComponent } from './components/shared/menu/menu.component';
import { PatternsComponent } from './components/develop/patterns/patterns.component';
import { LoginJwtComponent } from './components/login-jwt/login-jwt.component';
import { Helpers } from './helpers/helpers';
import { AuthJwtInterceptorService } from './services/auth-jwt-interceptor.service';
import { ToastrModule } from 'ngx-toastr';
import { CustomValidators } from './helpers/custom-validators';
import { SharedModule } from './components/shared/shared.module';
import { AuthInterceptorService } from './services/auth-interceptor.service';
import { AuthConfigModule } from './auth/auth-config.module';
import { CallbackComponent } from './components/callback/callback.component';
import { FileValidationService } from './services/file-interceptor';
import { BalloonsOverlayComponent } from './components/shared/balloons-overlay/balloons-overlay.component';//globos

const APP_CONTAINERS = [
  DefaultLayoutComponent
];

@NgModule({
  declarations: [
    AppComponent,
    FooterComponent,
    HeaderComponent,
    SidebarComponent,
    MenuComponent,
    PatternsComponent,
    LoginJwtComponent,
    CallbackComponent,
    BalloonsOverlayComponent,//globos
    ...APP_CONTAINERS,
  ],
  imports: [
    SharedModule,
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    RouterModule,
    BrowserAnimationsModule,
    ToastrModule.forRoot({
      maxOpened: 3,
      autoDismiss: true
    }),
    NgbModule,
    FontAwesomeModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    AuthConfigModule
  ],
  exports: [
    FontAwesomeModule
  ],
  providers: [
    Helpers,
    CustomValidators,
    {
      provide: LocationStrategy,
      useClass: PathLocationStrategy
    },
    { provide: LOCALE_ID, useValue: 'pt-PT' },
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptorService, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: AuthJwtInterceptorService, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: FileValidationService, multi: true }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
  constructor(library: FaIconLibrary) {
    library.addIcons(
      faSearch,
      faChevronLeft,
      faChevronRight,
      faCircleExclamation,
      faHeart,
      faDownload,
      faPlus,
      faXmark,
      faMagnifyingGlass,
      faFileDownload,
      faPaperPlane,
      faArrowLeft,
      faArrowRight,
      faArrowUpRightFromSquare,
      faFile,
      faHandPointUp,
      faEye,
      faEnvelope,
      faClone,
      faList,
      faSort,
      faCircleCheck
    );
  }
}
